import styled from 'styled-components';

interface Props {
  isActive: boolean;
}
export const Wrapper = styled.article`
  width: 100%;
  height: 100vh;
  padding: 32px;
  gap: 32px;
  border: 1px solid ${({ theme }) => theme.color.grey200};
  border-top: none;
  background: ${({ theme }) => theme.color.background};
  box-shadow: 1px 1px 0 0 rgba(11, 37, 80, 0.17);

  > hr {
    height: 1px;
    border-color: ${({ theme }) => theme.color.grey200};
    margin-bottom: 32px;
    margin-top: 32px;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  padding: 32px;
  background: ${({ theme }) => theme.color.white};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.color.grey200};
  box-shadow: 1px 1px 0 0 rgba(11, 37, 80, 0.17);
`;

export const BackToProfile = styled.section`
  color: ${({ theme }) => theme.color.grey600};
  font-family: Mulish;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: 0.08px;
  display: flex;
  align-items: center;
  margin-top: 32px;
  cursor: pointer;

  svg {
    margin-right: 4px;
    path {
      fill: ${({ theme }) => theme.color.grey600};
    }
  }
`;

export const SetNewEmailTitle = styled.div`
  font-family: AcidGrotesk-Bold;
  font-size: 28px;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: 0.28px;
  text-transform: capitalize;
  margin-top: 32px;
  margin-bottom: 20px;
`;

export const StyledSection = styled.section`
  max-width: 1300px;
  margin: 0 auto;
`;

export const StepSectionWrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color.grey200};
  margin-bottom: 80px;
`;

export const StepSection = styled.div`
  padding-right: 150px;
`;

export const StepItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 36px;
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    bottom: -24px;
    left: 16px;
    transform: translateX(-50%);
    width: 1px;
    height: 12px;
    background: ${({ theme }) => theme.color.grey600};
  }

  &:last-child {
    margin: 0;

    &:after {
      display: none;
    }
  }
`;

export const Step = styled.div<Props>`
  min-width: 32px;
  height: 32px;
  background: ${({ theme, isActive }) =>
    isActive ? theme.color.blue300 : theme.color.white};
  border: ${({ theme, isActive }) =>
    isActive ? 'none' : `1px solid ${theme.color.grey700}`};
  border-radius: 50%;
  color: ${({ theme }) => theme.color.grey900};
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Mulish;
  font-size: 16px;
  font-style: normal;
  font-weight: ${({ isActive }) => (isActive ? 700 : 500)};
  line-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StepText = styled.div<Props>`
  color: ${({ theme }) => theme.color.grey900};
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Mulish;
  font-size: 18px;
  font-style: normal;
  font-weight: ${({ isActive }) => (isActive ? 700 : 500)};
  line-height: 140%;
  margin-left: 10px;
`;
